import { makeStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

interface TableStyleProps {
  height?: string;
  hasStickyColumns?: boolean;
}

export const useStyles = makeStyles<Theme, TableStyleProps>((theme) => ({
  root: {
    ...theme.typography.body2,
    height: ({ height }) => height,
    display: "block",
    overflowX: ({ hasStickyColumns }) => (hasStickyColumns ? "hidden" : "auto"),
    overflowY: "hidden",
  },
  table: {
    display: "block",
    height: "100%",
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(1),
    color: theme.palette.common.black,
    boxSizing: "border-box",
    backgroundColor: theme.palette.grey[200],
  },
  tableNoData: {
    height: "min-content",
    minHeight: "2.5625rem !important",
    borderBottom: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    scrollbarWidth: "none",
    "& > div > div": {
      "&::-webkit-scrollbar": {
        width: 0,
        height: 0,
      },
    },
  },
  list: {
    width: "fit-content",
  },
  thead: {
    display: "block",
    position: "sticky",
    zIndex: 4,
    top: 0,
  },
  fixedSizeList: {
    border: "0px solid #fff",
    overflowX: ({ hasStickyColumns }) =>
      hasStickyColumns ? ("unset !important" as any) : "unset",
    borderRadius: theme.spacing(1),
    minHeight: "96px",
  },
  tbodyInfinite: {
    height: "calc(100% - 2.5rem)",
    minWidth: "100%",
    position: "relative",
    width: "100%",
    zIndex: ({ hasStickyColumns }) => (hasStickyColumns ? 0 : "unset"),
  },
  tbodyInfinite_filter: {
    position: "relative",
    width: "100%",
    height: "calc(100% - 6.25rem)",
  },
  th: {
    padding: "0 0.75rem",
    height: "2.5rem",
    backgroundColor: theme.palette.grey[50],
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: theme.spacing(1),
  },
  thHover: {
    "&:hover": {
      backgroundColor: theme.palette.grey[200],
    },
  },
  thSeparator: {
    position: "relative",
    "&::before": {
      position: "absolute",
      content: "''",
      right: 0,
      width: 1,
      height: "1.25rem",
      backgroundColor: theme.palette.grey[300],
    },
    "&:last-child&:before": {
      display: "none",
    },
  },
  thActiveFilter: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.common.black,
    },
  },
  thContent: {
    whiteSpace: "pre",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "flex",
    alignItems: "center",
  },
  tr: {
    margin: "0",
    padding: "0",
    backgroundColor: theme.palette.common.white,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    boxSizing: "border-box",
    "&:hover": {
      backgroundColor: theme.palette.grey[50],
    },
  },
  trFilter: {
    height: "2.75rem",
    boxSizing: "unset",
  },
  trLoading: {
    margin: 0,
    padding: 0,
    backgroundColor: theme.palette.grey[50],
    filter: "blur(4px)",
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
  },
  trHighlightedRow: {
    backgroundColor: theme.palette.grey[100],
  },
  td: {
    padding: "0 0.75rem",
    display: "flex",
    alignItems: "center",
    overflow: "auto",
    whiteSpace: "pre",
    backgroundColor: "inherit",
    borderColor: "transparent",
    borderWidth: "0 1px 0 1px",
    borderStyle: "solid",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      width: 0,
      height: 0,
    },
    "&:last-child": {
      borderWidth: "0 0 0 1px",
    },
    "&:first-child": {
      borderWidth: "0 1px 0 0",
    },
  },
  tdActiveFilter: {
    backgroundColor: "#F8FBFF",
    borderColor: theme.palette.grey[200],
  },
  trHover: {
    backgroundColor: theme.palette.grey[50],
  },
  trLoadingHover: {
    backgroundColor: theme.palette.grey[50],
  },
  sticky: {
    minHeight: "unset",
    "&[data-sticky-td]": {
      position: "sticky",
    },
  },
}));
